module.exports = __webpack_public_path__ + "img/log-out.282bc1fc.svg";